import { Accordion } from "@frends/ui-components/react";

export default Accordion;
